import { render, staticRenderFns } from "./StoreList.vue?vue&type=template&id=183655a6&scoped=true"
import script from "./StoreList.vue?vue&type=script&lang=js"
export * from "./StoreList.vue?vue&type=script&lang=js"
import style0 from "./StoreList.vue?vue&type=style&index=0&id=183655a6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183655a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('183655a6')) {
      api.createRecord('183655a6', component.options)
    } else {
      api.reload('183655a6', component.options)
    }
    module.hot.accept("./StoreList.vue?vue&type=template&id=183655a6&scoped=true", function () {
      api.rerender('183655a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/store/StoreList.vue"
export default component.exports